module.exports = __webpack_public_path__ + "static/media/doc.cbf25f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/doc.png
// module id = 40
// module chunks = 0